const BLOCKED_REASONS = new Set([null, 'unsupported_environment', 'runtime_not_ready', 'restore_quarantine']);

export function canManagePlatformZapierSettings(platform) {
  return platform?.admin === true && Array.isArray(platform.capabilities)
    && platform.capabilities.includes('platform.integrations.manage');
}

function invalidSettings() {
  return Object.assign(new Error('Zapier availability could not be confirmed.'), { code: 'invalid_zapier_settings_response' });
}

export function checkedPlatformZapierSettings(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)
    || typeof value.enabled !== 'boolean' || typeof value.effectiveEnabled !== 'boolean'
    || typeof value.canEnable !== 'boolean' || typeof value.restoreQuarantined !== 'boolean'
    || !Number.isSafeInteger(value.revision) || value.revision < 0
    || !['all_companies', 'enrolled_companies'].includes(value.scope)
    || !BLOCKED_REASONS.has(value.blockedReason)
    || value.canEnable !== (value.blockedReason === null)
    || value.effectiveEnabled !== (value.enabled && value.canEnable)
    || (value.enabled && value.scope !== 'all_companies')
    || (value.restoreQuarantined && value.canEnable)
    || (value.blockedReason === 'restore_quarantine' && !value.restoreQuarantined)
    || (value.blockedReason === 'unsupported_environment'
      && (value.enabled || value.revision !== 0 || value.scope !== 'all_companies' || value.restoreQuarantined))) throw invalidSettings();
  return { enabled: value.enabled, effectiveEnabled: value.effectiveEnabled, canEnable: value.canEnable,
    revision: value.revision, scope: value.scope, restoreQuarantined: value.restoreQuarantined, blockedReason: value.blockedReason };
}

export function platformZapierSettingsBody({ enabled, expectedRevision } = {}) {
  if (typeof enabled !== 'boolean' || !Number.isSafeInteger(expectedRevision) || expectedRevision < 0) throw invalidSettings();
  return { enabled, expectedRevision };
}

export function checkedPlatformZapierSettingsSave(value, request) {
  const next = checkedPlatformZapierSettings(value);
  if (next.enabled !== request.enabled || (request.enabled && next.scope !== 'all_companies')
    || next.revision < request.expectedRevision || next.revision > request.expectedRevision + 1) throw invalidSettings();
  return next;
}

export function canSavePlatformZapierSettings(snapshot, enabled) {
  return Boolean(snapshot && snapshot.blockedReason !== 'unsupported_environment'
    && (snapshot.enabled !== enabled || snapshot.scope !== 'all_companies')
    && (!enabled || snapshot.canEnable));
}

export function platformZapierReadinessMessage(reason) {
  return {
    unsupported_environment: 'Zapier availability cannot be changed in this environment.',
    runtime_not_ready: 'Zapier cannot be enabled until the delivery service is ready.',
    restore_quarantine: 'Zapier is held after a database restore. Complete the verified recovery procedure before enabling it.',
  }[reason] || '';
}
